interface CountryLimit {
    currency: string,
    limit: number
}

export const countryCurrencyLimit: CountryLimit[] = [
    {
        currency: "HUF",
        limit: 895000
    },
    {
        currency: "CZK",
        limit: 67740
    },
    {
        currency: "PLN",
        limit: 11245
    },
    {
        currency: "EUR",
        limit: 2500
    },
    {
        currency: "BGN",
        limit: 5000
    },
    {
        currency: "RON",
        limit: 12000
    }
]
